// Module
var code = "<div class=\"col-md-4\" ng-transclude> </div>";
// Exports
module.exports = code;